const enum AppLanguage {
  English = "en",
  German = "de",
  Italian = "it",
  French = "fr",
}

export default AppLanguage;
